
import { TLocaleType } from "applications/desktop/package-compare-app/components/root-app/types/root-app.types";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class LocaleSelector2 extends Vue {
  @Prop(Array) list: string[]
  @Prop(String) currentLocale: TLocaleType
}
